module.exports = __webpack_public_path__ + "img/high-voltage.d2062e21.svg";